export const comments_5129827 = {"data":{"data":[],"links":{}}}